import React from 'react'
import GenericPullAndPushToolView from '../GenericPullAndPushToolView'
import ApiiroConfigListing from './ApiiroConfigListing'
import ApiiroCredentialForm from './ApiiroCredentialForm'

export default function ApiiroPullAndPushView(props) {
    return (
        <GenericPullAndPushToolView 
            {...props}
            PullCredentialForm={ApiiroCredentialForm}
            PullConfigListingView={ApiiroConfigListing}
            RunOnDemandButtonText={'Sync tool images'}
        />
    )
}
